import { normalizeSlotLabel } from "@/lib/manufacturing/slotLabel";

export type RecipeLineMaterialSource = {
  line_kind: string;
  material_code: string;
  material_name: string;
  slot_label: string;
};

export type RecipeMaterialOption = {
  material_code: string;
  material_name: string;
};

/** Unique material codes from parent recipe lines, optionally filtered by transform slot labels. */
export function recipeMaterialOptionsForSlots(
  lines: readonly RecipeLineMaterialSource[],
  slots: readonly string[],
): RecipeMaterialOption[] {
  const slotFilter = new Set(
    slots.map((s) => normalizeSlotLabel(s)).filter((s) => s.length > 0),
  );
  const byCode = new Map<string, string>();
  for (const ln of lines) {
    if (ln.line_kind !== "material") continue;
    const code = ln.material_code.trim();
    if (!code) continue;
    if (slotFilter.size > 0 && !slotFilter.has(normalizeSlotLabel(ln.slot_label))) {
      continue;
    }
    if (!byCode.has(code)) byCode.set(code, ln.material_name);
  }
  return [...byCode.entries()]
    .map(([material_code, material_name]) => ({ material_code, material_name }))
    .sort((a, b) => a.material_code.localeCompare(b.material_code));
}
